// ---------------------------------------------- modules import
import M from "materialize-css";
import React, {
  ChangeEvent,
  FormEvent,
  FunctionComponent,
  useEffect
} from "react";
import { Link } from "react-router-dom";
import Spinner from "react-spinkit";

import { IAddFormProps } from "./common";
import { ThemeContext } from "../../../contexts/themeContext";
import { useAuth, usePostForAddForm } from "./hooks";
import PermissionHelper from "../../../store/helpers/permissionHelper";
import TagHelper from "../../../store/helpers/tagHelper";
import { pattern } from "../../../store/helpers/validationHelper";

// ---------------------------------------------- the component
const AddForm: FunctionComponent<IAddFormProps> = ({ menuIndex }) => {
  // ---------------------------------------------- local state
  const { auth, profile } = useAuth();
  const {
    post,
    isReady,
    isPostValid,
    categories,
    onChange,
    onAdd
  } = usePostForAddForm(menuIndex);

  const tags = TagHelper.toTags(post.tags);

  // ---------------------------------------------- handlers
  const handleChange = (e: ChangeEvent<HTMLInputElement | HTMLSelectElement>) =>
    onChange(e.currentTarget.name, e.currentTarget.value);

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    onAdd(auth, profile, `/${PermissionHelper.getUrl(menuIndex)}`);
  };

  // ---------------------------------------------- effects
  useEffect(() => {
    const selects = document.querySelectorAll("select");

    M.FormSelect.init(selects);
  }, []);

  // ---------------------------------------------- content
  return (
    <ThemeContext.Consumer>
      {({ theme }) => (
        <div className="container row">
          <form className="card col s12 m10 offset-m1" onSubmit={handleSubmit}>
            <div
              className="card-content row"
              style={{ marginBottom: "0px", paddingBottom: "0px" }}
            >
              <span style={{ fontSize: "0.75rem" }}>
                {PermissionHelper.getName(menuIndex).toLowerCase()}
              </span>

              <span className="card-title" style={{ marginBottom: "20px" }}>
                ADD FORM
              </span>

              <div className="input-field col s12 m6">
                <input
                  type="text"
                  id="title"
                  name="title"
                  className="validate"
                  pattern={pattern.post.title.toString().slice(1, -1)}
                  minLength={2}
                  maxLength={50}
                  onChange={handleChange}
                  required
                />

                <label htmlFor="title">Title</label>
              </div>

              <div className="input-field col s12 m6">
                <select
                  name="category"
                  defaultValue="0"
                  onChange={handleChange}
                >
                  <option value={0} disabled>
                    set category
                  </option>

                  {categories.map((category, index) => (
                    <option key={index} value={category}>
                      {category}
                    </option>
                  ))}
                </select>

                <label>Category</label>
              </div>

              <div className="input-field col s12" style={{ padding: "0px" }}>
                <div className="row" style={{ margin: "0px", padding: "0px" }}>
                  {tags.map(tag => (
                    <div
                      key={tag.index}
                      className="col s6 row"
                      style={{ margin: "0px", padding: "0px" }}
                    >
                      <div className="col s3">
                        <label>
                          <input
                            type="checkbox"
                            name="tags"
                            className="filled-in"
                            value={tag.index}
                            checked={tag.tagged}
                            onChange={handleChange}
                          />

                          <span />
                        </label>
                      </div>

                      <div
                        className="col s9"
                        style={{ fontSize: "0.65rem" }}
                      >{`#${tag.shortName.toLowerCase()}`}</div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="input-field card col s12 z-depth-3">
                <div
                  className="card-content row"
                  style={{ marginBottom: 0, paddingBottom: 0 }}
                >
                  <div id="codex-editor"></div>
                </div>

                {isReady ? null : (
                  <div className="center-align" style={{ marginTop: "3rem" }}>
                    <Spinner name="three-bounce" fadeIn="none" />
                  </div>
                )}

                <div
                  className="card-action right-align"
                  style={{ marginBottom: "0" }}
                />
              </div>
            </div>

            <div className="card-action row" style={{ marginBottom: "0" }}>
              <div className="col s6">
                <Link
                  to={`/${PermissionHelper.getUrl(menuIndex)}`}
                  className="btn-floating btn-small waves-effect waves-light"
                  style={{ backgroundColor: theme.ui }}
                >
                  <i className="material-icons left">arrow_back</i>
                </Link>
              </div>

              <div className="col s6 right-align">
                <button
                  type="submit"
                  className={`btn-small waves-effect waves-light ${
                    isPostValid() ? "" : "disabled"
                  }`}
                  style={{ backgroundColor: theme.ui }}
                >
                  Submit<i className="material-icons right">send</i>
                </button>
              </div>
            </div>
          </form>
        </div>
      )}
    </ThemeContext.Consumer>
  );
};

export default AddForm;
